// utils/dateFormatter.js
export function formatDate(dateInput) {
  if (!dateInput) return "-";

  const date = new Date(dateInput);
  if (isNaN(date)) return "-"; // handle invalid dates

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
